import {
  FETCH_PROMOTION_ASSETS,
  FETCH_PROMOTION_ASSETS_SUCCESS,
  FETCH_PROMOTION_ASSETS_FAILURE,
  SET_PROMOTION_DETAILS,
} from './constants';

export const fetchPromotionAssets = () => ({
  type: FETCH_PROMOTION_ASSETS,
});

export const fetchPromotionAssetsSuccess = (payload) => ({
  type: FETCH_PROMOTION_ASSETS_SUCCESS,
  payload,
});

export const fetchPromotionAssetsFailure = (payload) => ({
  type: FETCH_PROMOTION_ASSETS_FAILURE,
  payload,
});

export const setPromotionDetails = (payload) => ({
  type: SET_PROMOTION_DETAILS,
  payload,
});
